/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Nav_Badge_RequestsInputs */



/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} join request to review" |
* | * | "{count} join requests to review" |
*
* @param {Nav_Badge_RequestsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_badge_requests = /** @type {((inputs: Nav_Badge_RequestsInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Badge_RequestsInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") {
		const countPlural = registry.plural("de", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} Beitrittsanfrage zu prüfen`);
		return /** @type {LocalizedString} */ (`${i?.count} Beitrittsanfragen zu prüfen`)
	}
	if (locale === "fr") {
		const countPlural = registry.plural("fr", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} demande d'adhésion à examiner`);
		return /** @type {LocalizedString} */ (`${i?.count} demandes d'adhésion à examiner`)
	}
	if (locale === "zh-Hans") {
		const countPlural = registry.plural("zh-Hans", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} 条加入申请待审核`);
		return /** @type {LocalizedString} */ (`${i?.count} 条加入申请待审核`)
	}
	if (locale === "zh-Hant") {
		const countPlural = registry.plural("zh-Hant", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`有 ${i?.count} 筆加入申請待審核`);
		return /** @type {LocalizedString} */ (`有 ${i?.count} 筆加入申請待審核`)
	}
	if (locale === "ko") {
		const countPlural = registry.plural("ko", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`검토할 가입 요청 ${i?.count}건`);
		return /** @type {LocalizedString} */ (`검토할 가입 요청 ${i?.count}건`)
	}
	{
		const countPlural = registry.plural("en", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} join request to review`);
		return /** @type {LocalizedString} */ (`${i?.count} join requests to review`)
	}
});